import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import WhatsApp from "../assets/whatsapp.png";

import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";

import { useNavigate } from "react-router-dom";

import aboutHero from "../assets/gallery1.png";

import galleryBg from "../assets/DamroTeaState2.jpg";

function Gallery() {

    const navigate = useNavigate();

    const [galleryImages, setGalleryImages] = useState([]);
    const [selectedImg, setSelectedImg] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        AOS.init({ duration: 900, once: true });

        const fetchGalleryImages = async () => {
            try {
                const q = query(
                    collection(db, "gallery"),
                    orderBy("createdAt", "desc")
                );
                const snapshot = await getDocs(q);

                const images = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                setGalleryImages(images);
            } catch (error) {
                console.error("Error loading gallery images:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchGalleryImages();
    }, []);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-fill bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Gallery
                    </h1>

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        Moments captured across Sri Lanka
                    </p>
                </div>
            </section>

            {/* ================= GALLERY SECTION ================= */}
            <section className="py-12 bg-white">
                <div className="max-w-7xl mx-auto px-4">

                    {/* Loading */}
                    {loading && (
                        <p className="text-center text-gray-500">Loading images...</p>
                    )}

                    {/* Gallery Grid */}
                    {!loading && (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                            {galleryImages.map((img, index) => (
                                <div
                                    key={img.id}
                                    data-aos="zoom-in"
                                    data-aos-delay={index * 80}
                                    className="group relative overflow-hidden rounded-xl shadow-lg cursor-pointer"
                                    onClick={() => setSelectedImg(img.imageUrl)}
                                >
                                    <img
                                        src={img.imageUrl}
                                        alt={`Gallery ${index + 1}`}
                                        loading="lazy"
                                        className="w-full h-[260px] object-cover transition-transform duration-500 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition duration-500" />
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* ================= MODAL ================= */}
                {selectedImg && (
                    <div
                        className="fixed inset-0 bg-black/70 flex justify-center items-center z-50 p-4"
                        onClick={() => setSelectedImg(null)}
                    >
                        <div className="relative">
                            <button
                                onClick={() => setSelectedImg(null)}
                                className="absolute -top-4 -right-4 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold shadow-lg hover:bg-gray-200 transition z-50"
                            >
                                &times;
                            </button>

                            <img
                                src={selectedImg}
                                alt="Expanded"
                                onClick={(e) => e.stopPropagation()}
                                className="
                                    rounded-lg shadow-lg
                                    w-full
                                    max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-3xl
                                    max-h-[80vh] object-contain
                                "
                            />
                        </div>
                    </div>
                )}
            </section>

            {/* ================= PROMO HERO SECTION ================= */}
            <section className="relative w-full py-16 px-6">
                <div className="max-w-7xl mx-auto">
                    <div className="relative overflow-hidden rounded-2xl shadow-xl">

                        {/* Background Image */}
                        <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{ backgroundImage: `url(${galleryBg})` }} // You can replace with a new image if needed
                        />

                        {/* Dark Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />

                        {/* Content */}
                        <div className="relative z-10 px-8 py-20 md:py-28 md:px-16 text-white max-w-2xl">
                            <h2 className="text-3xl md:text-5xl font-semibold leading-tight">
                                Explore iconic destinations <br />
                                with expert insights
                            </h2>

                            <button
                                onClick={() => navigate("/contact")}
                                className="mt-8 bg-[#ff5a4e] hover:bg-[#e0483d] transition px-8 py-3 rounded-lg text-sm font-semibold tracking-wide"
                            >
                                BOOK YOUR ADVENTURE
                            </button>
                        </div>

                    </div>
                </div>
            </section>

            <div className="fixed bottom-20 right-5 z-50">

                {/* ICON BUTTON */}
                <div
                    onClick={() => {
                        const dropdown = document.querySelector(".goog-te-gadget-simple");
                        if (dropdown) {
                            dropdown.click();
                        } else {

                        }
                    }}
                    className="w-14 h-14 bg-white rounded-full shadow-lg flex items-center justify-center cursor-pointer hover:scale-110 transition"
                >
                    <img
                        src="https://www.gstatic.com/images/branding/product/1x/translate_24dp.png"
                        alt="Translate"
                        className="w-7 h-7"
                    />
                </div>

                {/* HIDDEN GOOGLE TRANSLATE */}
                <div id="google_translate_element" className="absolute opacity-0 pointer-events-none"></div>

            </div>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94750800887"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default Gallery;
